import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(actions.load.toString(), load);
}
